import React from "react";
import { FiInbox } from "react-icons/fi";

function NoDataFound({
  title = "No Data Found",
  message = "Nothing is available right now. Please check back later.",
}) {
  return (
    <div className="bg-white rounded-[20px] border border-gray-200 px-6 py-12 md:py-16 text-center">
      <div className="w-16 h-16 mx-auto mb-4 rounded-2xl bg-amber-50 border border-amber-200 flex items-center justify-center text-amber-600">
        <FiInbox className="w-7 h-7" />
      </div>
      <h3 className="web-h4 text-gray-900 mb-2">{title}</h3>
      <p className="web-body-md text-gray-500 max-w-[420px] mx-auto">{message}</p>
    </div>
  );
}

export default NoDataFound;
